import { render, staticRenderFns } from "./R.vue?vue&type=template&id=14943ea8&scoped=true"
import script from "./R.vue?vue&type=script&lang=js"
export * from "./R.vue?vue&type=script&lang=js"
import style0 from "./R.vue?vue&type=style&index=0&id=14943ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14943ea8",
  null
  
)

export default component.exports